import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import Offline from 'static/images/closed-image.png';
import PrimaryCta from 'components/Buttons/PrimaryCta';
import {
  getSectionNavColor,
  getSectionNavMediumColor
} from 'styles/helpers/getThemeStyles';
import {
  ITEM_DESCRIPTION_AND_PRICES,
  MENU_ITEM_NAMES
} from 'styles/constants/appearanceSectionNames';

const StyledRoot = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  marginLeft: '16px',
  marginRight: '16px',
  marginTop: '20px',
  [theme.breakpoints.down('md')]: {
    marginTop: '10px'
  }
}));

const StyledImage = styled('img')(({ theme }) => ({
  width: '196px',
  height: '192px',
  marginTop: '20px',
  marginBottom: '20px',
  [theme.breakpoints.down('md')]: {
    marginTop: '20px'
  }
}));

const StyledTitle = styled(Typography)(({ theme }) => {
  return {
    fontSize: '20px',
    fontWeight: 500,
    color: getSectionNavColor(theme)
  };
});

const StyledCopy = styled(Typography)(({ theme }) => {
  return {
    fontSize: '14px',
    color: getSectionNavMediumColor(theme)
  };
});

function LocationOffline({ logoDestinationUrl, title, description }) {
  const primaryCtaUrl = logoDestinationUrl || '/';
  const descriptionText = description || 'Please check back soon!';

  const titleStyles = { variant: MENU_ITEM_NAMES };

  const copyStyles = { variant: ITEM_DESCRIPTION_AND_PRICES };

  return (
    <StyledRoot>
      <StyledImage src={Offline} alt="offline" width="300px" />
      <Box mb="20px">
        <StyledTitle {...titleStyles}>{title}</StyledTitle>
      </Box>
      <Box mb="20px">
        <StyledCopy data-testid="location-offline-description" {...copyStyles}>
          {descriptionText}
        </StyledCopy>
      </Box>
      <PrimaryCta
        label="BACK TO WEBSITE"
        href={primaryCtaUrl}
        ownState={{
          button: theme => ({
            width: '171px',
            height: '36px',
            padding: '12px 6px 12px 6px',
            [theme.breakpoints.down('md')]: {
              width: '100%'
            }
          })
        }}
      />
    </StyledRoot>
  );
}

LocationOffline.propTypes = {
  logoDestinationUrl: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string
};

export default LocationOffline;
